import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NodeType } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/node-type';
import { NodoArbolMenu } from 'src/app/asistente-en-linea/components/asistencia-menu-arbol/models/nodo-arbol-menu';
import { Contexto } from 'src/app/asistente-en-linea/models/contexto';

@Component({
  selector: 'app-error-pie',
  templateUrl: './error-pie.component.html',
  styleUrls: ['./error-pie.component.scss']
})

export class ErrorPieComponent {
  @Input() public ctx: Contexto;
  @Input() nodo: NodoArbolMenu;
  @Output() renderMenuArbolEmitter = new EventEmitter<Object>();
  codigoAsistenteReporteError: string = "csei_csu";

  renderizarFormularioConsulta() {
    // this.ctx.tipoFormulario = "Persona";
    this.nodo.tipoFormulario = "0";
    this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio,codAsistente: this.ctx.codAsistente, codAsistenteError: this.codigoAsistenteReporteError, nodo: this.nodo, tipo: NodeType.Action,esReporteError:true })
  }

}
